// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"f37bbe4b","206":"3f0f039d","238":"ce28a45e","447":"9d9a9102","955":"f47a84d0"}[chunkId] + ".chunk.js";
};